import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from 'styled-components';
import { getThemeData } from '../utils/utils';
import { createMainStyleComponent, createStyleComponent } from '../utils/createStyleComponent';
var commonCss = function commonCss(props) {
  var _getThemeData = getThemeData(props, 'common'),
    fontFamily = _getThemeData.fontFamily,
    primary = _getThemeData.primary;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    body {\n      font-family: ", ";\n    }\n    .ued-primary-bg {\n      background-color: ", " !important;\n    }\n    .ued-primary-color {\n      color: ", " !important;\n    }\n    .ued-primary-border-color {\n      border-color: ", " !important;\n    }\n  "])), fontFamily, primary, primary, primary);
};
var CommonStyle = createStyleComponent('common', commonCss);
var CommonStyleComponent = createMainStyleComponent({
  name: 'build-in',
  styles: [CommonStyle]
});
export default CommonStyleComponent;